import { createFileRoute } from '@tanstack/react-router'
import HistoryDetailPage from '@/spa/pages/history/HistoryDetailPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/history/$id')({
  component: HistoryDetailPage,
  errorComponent: routeErrorComponent,
})
